<template>
  <detail-layout-two-columns :toEdge="false">
    <template slot="LeftCol">
      <base-header style="padding-left: 0px" icon="user" :content="header" />
      <invoice-new-document-dialog :dialogOpen="showNewDocument" :idFacturae="idFacturae" :idInvoice="idInvoice"
        @toggleDialog="toggleDialogs" @applyDialog="applyDialogHandler" />
      <invoice-new-attachment-dialog :pgeType="form.pgeType" :dialogOpen="showNewAttachment" :idFacturae="idFacturae"
        :idInvoice="idInvoice" @toggleDialog="toggleDialogAttachment" @applyDialog="applyDialogAttachmentHandler" />
      <div class="form-wrapper">
        <el-form :model="form" :rules="rules" ref="ruleForm">
          <div class="hideHScroll">
            <div class="lg:mb-4" v-if="role === 3">
              <base-ro-input :label="$t('clients.entity_name')" :data="form.Empresa" />
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row" v-if="!showEditModeOCRIA">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.num_factura')" :data="form.numFactura" />
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0" v-if="form.SerieFactura && form.SerieFactura.trim() !== ''">
                <base-ro-input :label="$t('invoices.serie_factura')" :data="form.SerieFactura" />
              </div>
            </div>
            <div class="flex flex-col lg:flex-row w-full gap-x-2" v-else>
              <label class="w-full text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">
                <base-editable-field-label
                  :label="$t('invoices.num_factura')"
                  :edited="formEditMode.numFactura"
                  required
                />
                <el-form-item prop="numFacturaMod">
                  <el-input
                    :disabled="isGeneralLoading"
                    class="w-full"
                    type="text"
                    v-model="form.numFacturaMod"
                    maxlength='20'
                  />
                </el-form-item>
              </label>
              <label class="w-full text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">
                <base-editable-field-label
                  :label="$t('invoices.serie_factura')"
                  :edited="formEditMode.SerieFactura"
                />
                <el-form-item prop="SerieFacturaMod">
                  <el-input
                    :disabled="isGeneralLoading"
                    class="w-full"
                    type="text"
                    v-model="form.SerieFacturaMod"
                    maxlength='20'
                  />
                </el-form-item>
              </label>
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row" v-if="!showEditModeOCRIA">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.emisor')" :data="form.NombreCIFEmisor" />
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.cif_emisor')" :data="form.cifEmisor" />
              </div>
            </div>
            <div class="flex flex-col lg:flex-row w-full gap-x-2" v-else>
              <label class="w-full text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">
                <base-editable-field-label
                  :label="$t('invoices.emisor')"
                  :edited="formEditMode.NombreCIFEmisor"
                  required
                />
                <el-form-item prop="NombreCIFEmisorMod">
                  <el-input
                    :disabled="isGeneralLoading"
                    class="w-full"
                    type="text"
                    v-model="form.NombreCIFEmisorMod"
                    maxlength='80'
                  />
                </el-form-item>
              </label>
              <label class="w-full text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">
                <base-editable-field-label
                  :label="$t('invoices.cif_emisor')"
                  :edited="formEditMode.cifEmisor"
                  required
                />
                <el-form-item prop="cifEmisorMod">
                  <el-input
                    :disabled="isGeneralLoading"
                    class="w-full"
                    type="text"
                    v-model="form.cifEmisorMod"
                    maxlength='30'
                  />
                </el-form-item>
              </label>
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.receptor')" :data="form.NombreCIFReceptor" />
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.cif_receptor')" :data="form.cifReceptor" />
              </div>
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row" v-if="!showEditModeOCRIA">
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_emision')" :data="form.fechaFactura" />
              </div>
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.total_invoice')" :data="form.importe + ''" />
              </div>
            </div>
            <div class="flex flex-col lg:flex-row w-full gap-x-2" v-else>
              <label class="w-full text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">
                <base-editable-field-label
                  :label="$t('invoices.fecha_emision')"
                  :edited="formEditMode.fechaFactura"
                  required
                />
                <el-form-item prop="fechaFacturaMod">
                  <el-date-picker
                    class="!w-full bg-white dark:bg-darkblue"
                    v-model="form.fechaFacturaMod"
                    type="date"
                    format="dd-MM-yyyy"
                    :clearable="false"
                    :disabled="isGeneralLoading"
                  />
                </el-form-item>
              </label>
              <label class="w-full text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">
                <base-editable-field-label
                  :label="$t('invoices.total_invoice')"
                  :edited="formEditMode.importe"
                  required
                />
                <el-form-item prop="importeMod">
                  <el-input
                    clearable
                    class="w-full"
                    v-model="form.importeMod"
                    type="number"
                    maxlength="9"
                    :disabled="isGeneralLoading"
                  />
                </el-form-item>
              </label>
            </div>
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <!-- <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('app.status')" :data="form.Estado"/>
                  </div> -->
              <!-- <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('invoices.tipo_factura')" :data="form.tipoInvoiceClass"/>
                  </div> -->
              <div class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="form.EsRecibida ? $t('app.forma_recepcion') : $t('app.forma_envio')"
                  :data="form.pgeTypeName" />
              </div>
              <div v-if="form.FechaAlta" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_alta')" :data="form.FechaAlta" />
              </div>
            </div>
            <!-- <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('invoices.tipo_factura')" :data="form.tipoFactura"/>
                  </div>
                  <div class="px-2 w-full mb-2 lg:mb-0">
                    <base-ro-input :label="$t('invoices.concepto')" :data="form.concepto"/>
                  </div>
              </div>    -->

            <div v-if="form.csv" class="lg:mb-4">
              <base-ro-input :label="$t('invoices.csv')" :data="form.csv" />
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.NumAsiento" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.seat_number')" :data="form.NumAsiento" />
              </div>
              <div v-if="form.FechaEntradaERP" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.erp_entry_date')" :data="form.FechaEntradaERP" />
              </div>
            </div>

            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="form.FechaPago" class="px-2 w-full mb-2 lg:mb-0">
                <el-form-item v-if="[7,18].includes(idEstado) && showInvoiceActions" prop="fechaFacturaDesde">
                  <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">{{ $t('invoices.fecha_pago') }}</label>
                  <span data-v-4d1f1364="" class="min-input-height flex items-center border-b border-solid border-gray-100 dark:text-darkblue-200 black:text-darkblue-500 dark:border-darkblue-600 whitespace-pre-wrap">
                    <el-date-picker class="bg-white dark:bg-darkblue"
                      v-model="form.FechaPagoMod" type="date" :picker-options="dateRangeOptions" format="dd-MM-yyyy" 
                      placeholder="" :clearable="false">
                    </el-date-picker>
                  </span>
                </el-form-item>
                <base-ro-input v-else :label="$t('invoices.fecha_pago')" :data="form.FechaPago" />
              </div>
              <div v-if="form.FechaRechazo" class="px-2 w-full mb-2 lg:mb-0">
                <base-ro-input :label="$t('invoices.fecha_rechazo')" :data="form.FechaRechazo" />
              </div>
            </div>

            <div v-if="form.UltimoError" class="lg:mb-4">
              <base-ro-input :label="$t('invoices.lastError')" :data="form.UltimoError" />
            </div>

            <div v-if="form.MotivoRechazo" class="lg:mb-4">
              <base-ro-input :label="$t('configurations.reject_msgs')" :data="form.MotivoRechazo" />
            </div>

            <div class="mt-8 lg:mb-4">
              <h3 v-if="!showEditModeOCRIA" class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.importes') }}</h3>
              <base-editable-field-label
                v-else
                class="dark:text-darkblue-200 font-bold mt-4 mb-2"
                :label="$t('invoices.importes')"
                :edited="formEditMode.importes"
                required
              />
              <el-table
                ref="importes"
                class="importes-table"
                :data="form.importesMod"
                style="width: 100%"
                :empty-text="$t('app.no_data_text')"
                :show-header="showEditModeOCRIA || form.importesMod.length > 0"
              >
                <el-table-column min-width="120">
                  <template slot="header">
                    <base-obligatory-icon v-if="showEditModeOCRIA" />{{ $t('impuestos.entity_name') }}
                  </template>
                  <template slot-scope="scope">
                    <span v-if="!showEditModeOCRIA">{{ getImpuestoName(scope.row.Clase) }}</span>
                    <el-form-item
                      v-else
                      :prop="'importesMod.' + scope.$index + '.Clase'"
                      :rules="importesRules.Clase"
                    >
                      <span :title="getImpuestoName(form.importesMod[scope.$index].Clase)">
                        <base-el-select
                          class="w-full"
                          :options="tiposCodigoImpuesto"
                          v-model="form.importesMod[scope.$index].Clase"
                          filterable
                          clearable
                          :disabled="isGeneralLoading || !isClaseEditable(scope.$index)"
                          :loading="isGeneralLoading"
                        />
                      </span>
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column min-width="120">
                  <template slot="header">
                    <base-obligatory-icon v-if="showEditModeOCRIA" />{{ $t('invoices.taxable_base') }}
                  </template>
                  <template slot-scope="scope">
                    <span v-if="!showEditModeOCRIA">{{ $n(scope.row.Base, 'currency') }}</span>
                    <el-form-item
                      v-else
                      :prop="'importesMod.' + scope.$index + '.Base'"
                      :rules="importesRules.Base"
                    >
                      <el-input
                        v-model="form.importesMod[scope.$index].Base"
                        type="number"
                        clearable
                        :disabled="isGeneralLoading"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column min-width="120">
                  <template slot="header">
                    <base-obligatory-icon v-if="showEditModeOCRIA" />{{ $t('invoices.tax_rate') }}
                  </template>
                  <template slot-scope="scope">
                    <span v-if="!showEditModeOCRIA">{{ scope.row.Tipo }}</span>
                    <el-form-item
                      v-else
                      :prop="'importesMod.' + scope.$index + '.Tipo'"
                      :rules="importesRules.Tipo"
                    >
                      <span :title="getTipoLabel(form.importesMod[scope.$index].Tipo)">
                        <base-el-select 
                          class="w-full" 
                          :options="tiposImpuestos" 
                          v-model="form.importesMod[scope.$index].Tipo"
                          filterable 
                          clearable 
                          :disabled="isGeneralLoading" 
                          :loading="isGeneralLoading"
                          @change="onTipoImpuestoChange(scope.$index)"
                          />
                      </span>

                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column min-width="120">
                  <template slot="header">
                    <base-obligatory-icon v-if="showEditModeOCRIA" />{{ $t('invoices.tax_amount') }}
                  </template>
                  <template slot-scope="scope">
                    <span v-if="!showEditModeOCRIA">{{ $n(scope.row.Importe, 'currency') }}</span>
                    <el-form-item
                      v-else
                      :prop="'importesMod.' + scope.$index + '.Importe'"
                      :rules="importesRules.Importe"
                    >
                      <el-input
                        v-model="form.importesMod[scope.$index].Importe"
                        type="number"
                        clearable
                        :disabled="isGeneralLoading"
                      />
                    </el-form-item>
                  </template>
                </el-table-column>
                <el-table-column v-if="showEditModeOCRIA" width="64" align="center">
                  <template slot-scope="scope">
                    <base-button-icon
                      name="trash"
                      mode="core"
                      :disabled="isGeneralLoading"
                      @click="removeImporte(scope.$index)"
                    />
                  </template>
                </el-table-column>
              </el-table>
              <div v-if="showEditModeOCRIA && showAddImporteButton" class="w-full m-2 float-right">
                <base-button-responsive
                  mode="primary"
                  :text="$t('invoices.new_importe')"
                  @click="addImporte"
                  icon="plus"
                  :disabled="isGeneralLoading"
                  class="m-5 float-right"
                />
              </div>
            </div>
            <div v-if="hasTBAIModule && !form.EsRecibida && hasTBAIInformation" class="mt-8 lg:mb-4">
                <h3 class="dark:text-darkblue-200 font-bold mt-4 md:mb-2 lg:mb-5">{{$t('invoices.informacion_ticketbai')}}</h3>
                <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0" v-if="form.estadoTicketbai">
                <base-ro-input :label="$t('invoices.estado_ticketbai')" :data="form.estadoTicketbai" />
                </div>
                <div v-if="form.fechaTicketbaiRegistro" class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('invoices.fecha_registro_ticketbai')" :data="form.fechaTicketbaiRegistro" />
                </div>
              </div>
                <div class="lg:mb-4" v-if="form.IdTBAI">
                  <base-ro-input :label="$t('invoices.id_ticketbai')"
                  :data="form.IdTBAI" />
              </div> 
                <div class="lg:mb-4" v-if="form.CSVEnvioTBAI">
                  <base-ro-input :label="$t('invoices.csv_ticketbai')"
                  :data="form.CSVEnvioTBAI" />
              </div> 
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0" v-if="form.Hacienda">
                  <div class="flex-col">
                    <label class="text-sm font-semibold text-secondary-600 dark:text-darkblue-400 black:text-darkblue-500 block mb-1">{{ form.fechaTicketbaiEnvio? $t('companies.enviada_hacienda'):$t('companies.pendiente_hacienda') }}</label>
                    <span class="min-input-height flex items-center border-b border-solid border-gray-100 dark:text-darkblue-200 black:text-darkblue-500 dark:border-darkblue-600 whitespace-pre-wrap">{{ form.Hacienda }}</span>
                    <base-button class="mt-1" @click.prevent="openUrlHacienda" :text="$t('invoices.consultar_hacienda')"></base-button>
                  </div>
                </div>
                <div v-if="form.fechaTicketbaiEnvio" class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('invoices.fecha_entrega_ticketbai')" :data="form.fechaTicketbaiEnvio" />
                </div>
              </div>
              <div v-if="form.ResultadosValidacion" class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.tbai_validation') }}</h3>
              <el-table ref="ResultadosValidacion" :data="form.ResultadosValidacion" style="width: 100%" height="250"
                :show-header="form.ResultadosValidacion && form.ResultadosValidacion.length > 0">
                <el-table-column prop="Codigo" label="Codigo" show-overflow-tooltip align="center">
                </el-table-column>
                <el-table-column prop="Descripcion" label="Descripcion" min-width="400" show-overflow-tooltip>
                </el-table-column>
              </el-table>
            </div>
            </div>
            <div v-if="hasVerifactuModule && !form.EsRecibida && hasVerifactuInformation" class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 md:mb-2 lg:mb-5">{{$t('invoices.informacion_verifactu')}}</h3>
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <base-ro-input :label="$t('invoices.qr_verifactu')" :data="form.urlVerifactu" />
                </div>
              </div>
              <div class="lg:mb-4" v-if="form.CsvAEAT">
                <base-ro-input :label="$t('verifactu.csvaeat')"
                  :data="form.CsvAEAT" />
              </div> 
              <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
                <div class="px-2 w-full mb-2 lg:mb-0">
                  <div class="flex-row">
                    <base-button class="mt-1" @click.prevent="openUrlVerifactu" :text="$t('invoices.consultar_aeat')"></base-button>
                  </div>
                </div>
                <div v-if="form.IdEstadoVerifactu" class="px-2 w-full mb-2 lg:mb-0">
                  <div class="flex-row">
                    <base-button class="mt-1" @click.prevent="goVerifactu" :text="$t('verifactu.related_verifactu')"></base-button>
                  </div>
                </div>
              </div>
            </div>
            
            <div class="lg:mb-4 flex -mx-2 flex-col lg:flex-row">
              <div v-if="hasFacturae" class="px-2 w-full mb-2 lg:mb-0">
                <div class="flex-col">
                  <base-button class="mt-1" @click.prevent="goInvoice" :text="$t('verifactu.related_facturae')"></base-button>
                </div>
              </div>
            </div>

            <div class="mt-8 lg:mb-4">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.invoices_documents') }}</h3>
              <el-table ref="documentos" :data="form.Adjuntos" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="form.Adjuntos && form.Adjuntos.length > 0">
                <el-table-column prop="tipo" width="36" align="center">
                  <template slot-scope="tipos">
                    <el-tooltip v-if="tipos.row.tipo" placement="left">
                      <div slot="content">
                        <div class="max-w-sm max-h-500p overflow-auto">
                          <div v-if="tipos.row.tipo === 'xml'">{{ $t('invoices.xml_invoice') }}</div>
                          <div v-else>{{ $t('invoices.document_adj_emb_long') }}</div>
                        </div>
                      </div>
                      <base-icon :name="tipos.row.tipo" />
                    </el-tooltip>
                  </template>
                </el-table-column>
                <el-table-column prop="Nombre" :label="$tc('app.documents', 1)" min-width="140" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="actions" width="200" align="center" :label="$tc('app.actions', 2)">
                  <template slot-scope="adjuntos">
                    <div class="flex flex-row">
                      <base-button-icon v-if="adjuntos.row.icon === 'eye' || adjuntos.row.icon === 'eyeslash'"
                        class="mr-2" @click="showAdjunto(adjuntos.row, true)" :name="adjuntos.row.icon" mode="core" />
                      <base-button-icon @click="downloadAdjunto(adjuntos.row, false)" name="download" mode="core" />
                      <base-button-icon @click="printAdjunto(adjuntos.row, false)" name="printer" mode="core" />
                      <base-button-icon v-if="adjuntos.row.Extension === 'xml'" class="mr-2"
                        @click="showEmbedXml(adjuntos.row, false)" :name="adjuntos.row.visible && showXml ? 'embedslash': 'embed' " mode="core"/>
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="Extension" :label="$t('app.extension')" width="90">
                </el-table-column>
                <el-table-column prop="actions" width="90" label="" v-if="showDeleteColumn">
                  <template slot-scope="scope">
                    <!-- <span @click.stop="download" class="icon-download p-2 cursor-pointer text-primary-900" /> -->
                    <base-button-icon
                      v-if="idEstado === 0 && scope.row.idRelatedDocument !== 0 && scope.row.Relacionado === false && showInvoiceActions"
                      @click="deleteAdjunto(scope.row)" name="trash" mode="core" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="w-full m-2 float-right">
              <base-button-responsive
                v-if="[0, 10].includes(idEstado) && showInvoiceActions && !disableAdjuntosExternos" mode="primary"
                :text="$t('invoices.new_adjunto')" @click="newAttachment()" icon="plus" class="m-5 float-right" />
            </div>
            <div class="mt-8">
              <h3 class="dark:text-darkblue-200 font-bold mt-4 mb-2">{{ $t('invoices.documents_rel') }}</h3>
              <el-table ref="documentosRel" :data="form.DocumentosRelacionados" style="width: 100%" :empty-text="$t('app.no_data_text')"
                :show-header="form.DocumentosRelacionados && form.DocumentosRelacionados.length > 0">
                <el-table-column prop="Nombre" :label="$tc('app.documents', 2)" min-width="200" show-overflow-tooltip>
                </el-table-column>
                <el-table-column prop="actions" width="120" align="center" :label="$tc('app.actions', 2)">
                  <template slot-scope="relacionados">
                    <div class="flex flex-row">
                      <base-button-icon v-if="relacionados.row.icon === 'eye' || relacionados.row.icon === 'eyeslash'"
                        class="mr-2" @click="showDocRel(relacionados.row, true)" :name="relacionados.row.icon"
                        mode="core" />
                      <base-button-icon v-else-if="relacionados.row.Extension === 'xml'" class="mr-2"
                        @click="showEmbedXml(relacionados.row, true)" :name="relacionados.row.visible && showXml ? 'embedslash': 'embed' " mode="core"/>
                      <base-button-icon @click="downloadAdjunto(relacionados.row, true)" name="download" mode="core" />
                    </div>
                  </template>
                </el-table-column>
                <el-table-column prop="Extension" :label="$t('app.extension')" width="90">
                </el-table-column>
                <el-table-column prop="actions" width="64" label="">
                  <template slot-scope="scope">
                    <!-- <span @click.stop="download" class="icon-download p-2 cursor-pointer text-primary-900" /> -->
                    <base-button-icon v-if="showInvoiceActions" @click="deleteDocRel(scope.row)" name="trash"
                      mode="core" />
                  </template>
                </el-table-column>
              </el-table>
            </div>
            <div class="w-full m-2 float-right">
              <base-button-responsive v-if="showInvoiceActions" mode="primary" :text="$t('app.new_document')"
                @click="newDocument()" icon="plus" class="m-5 float-right" />
            </div>
            <metadatos-table-view v-show="form.idEstado !== 12" :showActions="showInvoiceActions"
              :idCliente="form.idCliente" :idFacturae="idFacturae" :idInvoice="idInvoice" :metadatos="form.Metadatos"
              @updateDataTable="downloadInvoiceDataMetadata({ idInvoice, idFacturae, })" />
            <div class="pb-10">
              <label class="dark:text-darkblue-200 text-sm font-semibold text-secondary-600 block mb-1">{{
                $t('invoices.notas') }}</label>
              <el-form-item prop="full_text">
                <el-input :disabled="role === 4" type="textarea" :rows="3" clearable class="w-full"
                  v-model="form.full_text" maxlength="1000" />
              </el-form-item>
            </div>
          </div>
        </el-form>
      </div>
    </template>
    <template slot="RightCol">
      <div :class="{ 'h-screen': showPdf }"
        class="bg-primary-50 dark:bg-darkblue-800 dark:text-darkblue-200 xl:inline-block relative w-full flex-grow hideHScroll lg:h-full divide-y-2 divide-blue-200 dark:divide-gray-800">
        <img v-if="!showXhtml && !showPdf && showImage && !showXml" :src="srcImage" :alt="imageFilename" class="m-auto">
        <PDFViewerApp v-show="!showXhtml && showPdf && !showImage && !showXml" :search="actualFilterContent"
          @pdfViewerOpenHandler="pdfViewerOpenHandler" :pdf="url" :name="viewerFilename" />
        <div v-if="showXhtml && !showPdf && !showImage && !showXml" class="w-full h-full p-2 iframe-xhtml">
          <iframe id="container-xhtml-iframe" class="w-full p-2 iframe-xhtml" scrolling="auto" ref="frame">
          </iframe>
        </div>
        <div v-if="!showXhtml && !showPdf && !showImage && showXml" class="p-4 pt-6 h-full overflow-auto">
          <span v-show="false" v-safe-html="xmlData"></span>
          <xml-document class="w-full p-2 iframe-xhtml" :xml-string="xmlData"/>
        </div>
      </div>
      <!-- <base-dropdown-floating-button v-if="showXhtml" mode="primary" :secondaryButtons="facturaeActions" hover /> -->
      <base-button-icon v-if="showXhtml" name="printer" mode="primary" iconSize="lg" size="xl" @click="printXMLView"
        class="fixed right-10" :class="{ 'bottom-14': !showButtonChatbot, 'bottom-36': showButtonChatbot }" />
    </template>
    <template slot="layout-extend">
      <base-footer>
        <template slot="actions">
          <base-button-responsive mode="secondary" :text="$t('app.back')" icon="cross" @click="goBack"
            :loading="isGeneralLoading" :disabled="isGeneralLoading" />
          <base-button-responsive v-if="canUseCopyClipboard" mode="primary" :text="$t('invoices.copy_link_download')"
            @click="copyLinkDownload()" icon="copy" :loading="isGeneralLoading" :disabled="isGeneralLoading" />

          <base-table-select-actions-form v-if="hasInvoiceActions && !isGeneralLoading"
            :baseDropDownVisible="hasInvoiceActions"
            :name="$tc('app.actions', 2)">
            <template slot="more">
              <span v-for="action in invoiceActions" :key="action.IdAccion">
                <base-button-item-list v-if="showAction(action)" theme="dark" @click="showActionModal(action)">
                  <base-icon :name="selectActionIcon(action)" class="mr-2" />
                  <div class="w-72 text-left">
                    {{ action.Descripcion }}
                  </div>
                </base-button-item-list>
              </span>
            </template>
          </base-table-select-actions-form>

          <!--<base-button-responsive  v-for="action in invoiceActions" :key="action.IdAccion"
            mode="primary"
            :text="action.Descripcion"
            @click="showActionModal(action)"
            :icon="selectActionIcon(action)"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          /> -->

          <!-- <base-button-responsive
            v-if="showEditModeOCRIA"
            mode="primary"
            :text="showEditModeOCRIA ? $t('configurations.cancel_mode_edit') : $t('configurations.change_mode_edit')"
            @click="toggleEditMode()"
            icon="editpencil"
            :loading="isGeneralLoading"
            :disabled="isGeneralLoading"
          /> -->
          <base-button-responsive v-if="!showEditModeOCRIA || !hasWorkflowInformation" mode="primary" :text="showEditModeOCRIA ? $t('app.confirm_and_save') : $t('app.save')"
            @click="submitForm('ruleForm')" icon="check" :loading="isGeneralLoading" :disabled="isGeneralLoading" />

        </template>
      </base-footer>
      <Dialog :title="$t('invoices.dialogs.delete_recurrence_header')" :visible.sync="showModalDeleteRecurrence" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDeleteRecurrence
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalDeleteRecurrence = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.accept')"
              @click="() => { deleteRecurrenceHandler(); showModalDeleteRecurrence = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('invoices.delete_invoice')" :visible.sync="showModalDelete" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessageDelete
        }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModalDelete = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { submitAction(); showModalDelete = false }" />
          </div>
        </template>
      </Dialog>
      <Dialog :title="$t('invoices.send_invoice')" :visible.sync="showModal" width="40%" custom-class="min-width-dialog" center>
        <span class="text-center w-full inline-block dark:text-darkblue-200 word-break-n">{{ processMessage }}</span>
        <template slot="footer">
          <div class="flex flex-col lg:flex-row w-full lg:w-auto items-center space-y-2 lg:space-y-0 lg:space-x-2">
            <base-button class="w-full" @click="showModal = false" mode="secondary-phantom-blue"
              :text="$t('app.cancel')" />
            <base-button class="w-full" mode="secondary-phantom-blue" :text="$t('app.apply')"
              @click="() => { submitAction(); showModal = false }" />
          </div>
        </template>
      </Dialog>


      <input-text-mail-from-white-list-dialog :dialogOpen="showModalWhiteMail" :id-cliente="idCliente"
        :header="$t('invoices.dialogs.emails_dialog_header')" @toggleDialog="newWhiteMailToggleDialog" @applyDialog="applyNewWhiteMailDialog" />



      <reject-invoice-dialog :dialogOpen="rejectDialog" @toggleDialog="toggleRejectDialog"
        @applyDialog="applyRejectDialog" />
      <invoice-correction-dialog :dialogOpen="showCorrectionModal" :id-facturae="idFacturae" :id-invoice="idInvoice"
        @toggleDialog="toggleCorretionDialog" @applyDialog="applyCorretionDialog" />
      <invoice-recurrence-dialog :dialogOpen="showRecurrenceModal" :id-facturae="idFacturae"
        :id-invoice="idInvoice" :id-factura-recurrente="idRecurrente" :edit-recurrence="editRecurrencia" @toggleDialog="toggleRecurrenceDialog" @applyDialog="applyRecurrenceDialog" />
      <to-invoice-proforma-dialog :dialogOpen="showProformaModal" :invoice="invoice"
        :to-proforma="toProforma" @toggleDialog="toggleProformaDialog" @applyDialog="applyProformaDialog" />
      <invoice-workflow-dialog :dialogOpen="showModalWorkflow" :header="headerWorkflow" :idFlujoAprobacion="[idFlujoAprobacion]"
        :workflowAction="workflowAction" @toggleDialog="showModalWorkflow = false" 
        @applyDialog="(workflowForm) => { applyWorkflowHandler(workflowForm); showModalWorkflow = false }" />
    </template>
  </detail-layout-two-columns>
</template>

<script>
import moment from 'moment'
import { i18n } from '@/i18n'
import { mapGetters } from 'vuex'
import { bus } from '@/main'

import InputTextMailFromWhiteListDialog from '@/components/InputTextMailFromWhiteListDialog.vue'
import InvoiceNewAttachmentDialog from '@/components/InvoiceNewAttachmentDialog.vue'
import DetailLayoutTwoColumns from '@/components/layout/DetailLayoutTwoColumns.vue'
import InvoiceNewDocumentDialog from '@/components/InvoiceNewDocumentDialog.vue'
import ToInvoiceProformaDialog from '@/components/ToInvoiceProformaDialog.vue'
import InvoiceCorrectionDialog from '@/components/InvoiceCorrectionDialog.vue'
import InvoiceRecurrenceDialog from '@/components/InvoiceRecurrenceDialog.vue'
import RejectInvoiceDialog from '@/components/RejectInvoiceDialog.vue'
import MetadatosTableView from '@/components/MetadatosTableView.vue'
import BaseButtonIcon from '@/components/base/BaseButtonIcon.vue'
import PDFViewerApp from '@/components/pdf/PDFViewerApp.vue'
import XMLDocument from '@/components/XMLDocument.vue'
import InvoiceWorkflowDialog from '@/components/InvoiceWorkflowDialog.vue'
import { Dialog } from 'element-ui'

import { getXHTMLFactura } from '@/services/invoices/getXHTMLFactura'
import { getInvoice } from '@/services/invoices/getInvoice'
import { updateFactura } from '@/services/invoices/updateFactura'
import { actualizarEstadoAccion } from '@/services/invoices/actualizarEstadoAccion'
import { detenerFacturaRecurrente } from '@/services/invoices/detenerFacturaRecurrente'

import { aceptarWorkflow } from '@/services/configurations/workflow/aceptarWorkflow'
import { rechazarWorkflow } from '@/services/configurations/workflow/rechazarWorkflow'
import { reasignarWorkflow } from '@/services/configurations/workflow/reasignarWorkflow'

import { descargarAdjunto } from '@/services/invoices/descargarAdjunto'
import { getAdjunto } from '@/services/invoices/getAdjunto'
import { descargarDocRel } from '@/services/invoices/descargarDocRel'
import { getDocRel } from '@/services/invoices/getDocRel'
import { eliminarAdjunto } from '@/services/invoices/eliminarAdjunto'
import { eliminarDocRel } from '@/services/invoices/eliminarDocRel'
import { descargarDocFactura } from '@/services/invoices/descargarDocFactura'
import { getDocFactura } from '@/services/invoices/getDocFactura'
import { sendAvisoCorreoManual } from '@/services/invoices/sendAvisoCorreoManual'
import { sendinvoizeinmatic } from '@/services/invoices/sendinvoizeinmatic'
import { enviarCobroEmail } from '@/services/invoices/enviarCobroEmail'
import { getDocumentoPrioritario } from '@/services/invoices/getDocumentoPrioritario'
import { getImpuestosSimple } from '@/services/configurations/getImpuestosSimple'

import Roles from '@/config/roles'


import icons from '@/components/icons/_iconLibrary'
import Modulos from '../../classes/enums/Modulos'

export default {
  name: 'invoice',
  components: {
    DetailLayoutTwoColumns,
    InvoiceNewDocumentDialog,
    InvoiceNewAttachmentDialog,
    MetadatosTableView,
    RejectInvoiceDialog,
    PDFViewerApp,
    Dialog,
    BaseButtonIcon,
    InvoiceCorrectionDialog,
    ToInvoiceProformaDialog,
    InvoiceRecurrenceDialog,
    'xml-document': XMLDocument,
    InputTextMailFromWhiteListDialog,
    InvoiceWorkflowDialog
  },
  data: function () {
    return {
      dateRangeOptions: {
        firstDayOfWeek: 1,
        disabledDate: this.disabledDate
      },
      showNewDocument: false,
      showNewAttachment: false,
      showPdf: false,
      showXhtml: false,
      showImage: false,
      showXml: false,
      srcImage: '',
      imageFilename: '',
      xmlData: '',
      activeName: 'es',
      header: {
        title: i18n.t('invoices.header_long'),
        icon: 'docblack',
        breadcrumb: {},
        nav: [],
        url: 'invoicesissued'
      },
      reg: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,24}))$/,
      invoice: null,
      tiposImpuestos: [],
      cifEmisores: [],
      suppressEditWatchers: false,
      editBaseline: {},
      formEditMode: {
        numFactura: false,
        SerieFactura: false,
        NombreCIFEmisor: false,
        cifEmisor: false,
        fechaFactura: false,
        importe: false,
        importes: false,
      },
      form: {
        DocumentosRelacionados: [],
        Empresa: '',
        numFactura: '',
        SerieFactura: '',
        fechaFactura: '',
        fechaFacturaMod: null,
        idCliente: 0,
        cifReceptor: '',
        NombreCIFReceptor: '',
        cifEmisor: '',
        NombreCIFEmisor: '',
        importe: null,
        tipoFactura: null,
        full_text: '',
        enlaceDescarga: '',
        idEstado: -1,
        Estado: '',
        tipoInvoiceClass: '',
        importes: [],
        contentHhtmlXslt: '',
        csv: '',
        NumAsiento: '',
        FechaEntradaERP: '',
        FechaPago: '',
        FechaRechazo: '',
        FechaAlta: '',
        UltimoError: '',
        MotivoRechazo: '',
        pgeType: '',
        EsOCREditable: false,
        pgeTypeName: '',
        EsRecibida: false,
        FacturaeFile: null,
        idGrupoPropietario: null,
        Adjuntos: [],
        Metadatos: [],
        esPropietario: false,
        fechaTicketbaiRegistro: '',
        fechaTicketbaiEnvio: '',
        IdTBAI: null,
        estadoTicketbai: null,
        Hacienda: '',
        urlHacienda: '',
        CSVEnvioTBAI: '',
        ResultadosValidacion: [],
        urlVerifactu: '',
        CsvAEAT: '',
        CSVVerifactuZC: '',
        NumSerieFact: '',
        IdNifEmpresa: '',
        IdEstadoVerifactu: '',
        EstadoFactura: false,
        OrigenFactura: '',
        idFacturaRecurrente: null,
        idEstadoRelacionado: null,
        idFacturaeRelacionado: null,
        idInvoiceRelacionado: null,
        FlujoAprobacionFacturaInfo: null,
        // Formulario de validación por IA
        numFacturaMod: '',
        SerieFacturaMod: '',
        NombreCIFEmisorMod: '',
        cifEmisorMod: '',
        FechaPagoMod: '',
        importeMod: null,
        importesMod: [],
      },
      rules: {
        numFacturaMod: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        fechaFacturaMod: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        importeMod: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        NombreCIFEmisorMod: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        cifEmisorMod: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              // Expresión regular que solo permite letras y números
              const noSpecialChars = /^[a-zA-Z0-9]*$/
              if (value && !noSpecialChars.test(value)) {
                return callback(new Error(i18n.t('validation.special_caracter')))
              }
              callback()
            } 
          }
        ],
      },
      importesRules: {
        Base: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
        Clase: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'change'
          }
        ],
        Tipo: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          },
          {
            trigger: 'blur',
            validator: (rule, value, callback) => {
              const v = parseFloat(value)
              if (isNaN(v) || v < 0 || v > 100) {
                callback(new Error(i18n.t('validation.taxrate')))
              } else {
                callback()
              }
            }
          }
        ],
        Importe: [
          {
            required: true,
            message: i18n.t('app.fill_data'),
            trigger: 'blur'
          }
        ],
      },
      url: '',
      viewerFilename: '',
      documentError: undefined,
      enableUploader: false,
      idLastAdjuntoVisible: 0,
      invoiceActions: [],
      listaAccionesRecurrentes: [
        { IdAccion: 26, Descripcion: i18n.t('tipos.accion.add_recurrence') },
        { IdAccion: 27, Descripcion: i18n.t('tipos.accion.edit_recurrence') },
        { IdAccion: 28, Descripcion: i18n.t('tipos.accion.delete_recurrente') },
      ],
      listaAccionesUsuarioCliente: [
        { IdAccion: 300, Descripcion: i18n.t('tipos.accion.generate_payment_link') },
        { IdAccion: 304, Descripcion: i18n.t('tipos.accion.send_to_inmatic') },
      ],
      workflowAction: null,
      headerWorkflow: null,
      showModalWorkflow: false,
      showModalWhiteMail: false,
      showModal: false,
      showCorrectionModal: false,
      showProformaModal: false,
      toProforma: false,
      showModalDelete: false,
      showRecurrenceModal: false,
      showModalDeleteRecurrence: false,
      editRecurrencia: false,
      processMessage: i18n.t('invoices.dialogs.send_invoice_header'),
      processMessageDelete: i18n.t('invoices.dialogs.delete_invoice_header'),
      processMessageDeleteRecurrence: i18n.t('invoices.dialogs.delete_recurrence_dialog'),
      selectedAction: null,
      actualFilterContent: null,
      rejectDialog: false,
      facturaeActions: [{
        name: 'download',
        listener: () => this.downloadXMLView(),
        loading: false,
      },
      {
        name: 'printer',
        listener: () => this.printXMLView(),
        loading: false,
      }],
      xsltTemplate: ''
    }
  },
  watch: {
    showXhtml: function (value, oldValue) {
      if (value) {
        setTimeout(() => {
          this.insertIframeContent()
        }, 200)
      }
    },
    '$route.params': function (params, oldParams) {
      this.reloadInvoice()
    },
  },
  computed: {
    ...mapGetters('app', ['showButtonChatbot']),
    showEditModeOCRIA () {
      return this.form.pgeType === 'OCRIA' && this.form.EsOCREditable && this.form.EsRecibida && (!this.hasWorkflowInformation || this.isTurnWorkflow) && this.hasOCRIAModule // && this.hasAllPropietariosByGroups
    },
    pgeTypes: function () {
      return this.form.EsRecibida ? this.$store.getters['config/TIPOS_PGE_RECEPCION'] : this.$store.getters['config/TIPOS_PGE']
    },
    tiposEstado: function () {
      if (this.form.EsRecibida) {
        return this.$store.getters['config/TIPOS_ESTADO_RECEPCION']
      }
      return this.$store.getters['config/TIPOS_ESTADO']
    },
    idFlujoAprobacion: function () {
      return this.form.FlujoAprobacionFacturaInfo?.IdFlujoAprobacion || null
    },
    accionesFlujo: function () {
      return this.$store.getters['config/ACCIONES_FLUJO_APROBACION']
    },
    tiposAccion: function () {
      return this.$store.getters['config/TIPOS_ACCION']
    },
    tiposHacienda: function () {
      return this.$store.getters['config/TIPOS_HACIENDA']
    },
    tiposEstadoTBAI: function () {
      return this.$store.getters['config/TIPOS_ESTADOS_TBAI']
    },
    tiposCodigoImpuesto: function () {
      return this.$store.getters['config/TIPOS_CODIGO_IMPUESTO']
    },
    disableAdjuntosExternos () {
      return this.form.pgeType === 'OSAKIDETZA'
    },
    isGeneralLoading: function () {
      return this.$store.getters.isLoading
    },
    userId: function () {
      return this.$store.getters['auth/userId']
    },
    role: function () {
      return this.$store.getters['auth/role']
    },
    hasTBAIModule () {
      return !!this.$store.getters['auth/hasTBAIModule']
    },
    hasVerifactuModule () {
      return !!this.$store.getters['auth/hasVerifactuModule']
    },
    hasFacturae: function () {
      return this.form.idFacturaeRelacionado && this.form.idInvoiceRelacionado
    },
    showInvoiceActions: function () {
      return this.role !== 4 && this.hasAllPropietariosByGroups
    },
    hasInvoiceActions: function () {
      return this.invoiceActions.length > 0
    },
    isCollapsed: function () {
      return (this.collapse ? 'expand' : 'collap')
    },
    idInvoice: function () {
      return parseInt(this.$route.params.idInvoice)
    },
    idFacturae: function () {
      return parseInt(this.$route.params.idFacturae)
    },
    idEstado: function () {
      return parseInt(this.$route.params.type)
    },
    idRecurrente: function () {
      return this.form.idFacturaRecurrente
    },
    fromGeneral: function () {
      return this.$route.params.fromGeneral
    },
    routeBack: function () {
      var invoiceType = this.form.EsRecibida ? 'received' : 'issued'
      if (!this.fromGeneral) return `/invoices${invoiceType}/${this.idEstado}`
      else return `invoices${invoiceType}`
    },
    canUseCopyClipboard: function () {
      return !!this.form.enlaceDescarga
    },
    hasOCRIAModule: function () {
      return this.$store.getters['auth/hasOCRIAIntegrationModule']
    },
    hasIOCRModule: function () {
      return this.$store.getters['auth/hasOCRIntegrationModule']
    },
    hasIERPModule: function () {
      return this.$store.getters['auth/hasERPIntegrationModule']
    },
    hasRecurrentesModule: function () {
      return this.$store.getters['auth/hasRecurrentesModule']
    },
    hasModuleWorkflow: function () {
      return this.$store.getters['auth/hasApprovalWorkflowModule']
    },
    hasModuleInmatic: function () {
      return !!this.$store.getters['auth/hasInmaticModule']
    },
    iocrStates: function () {
      return this.tiposEstado.filter(x => x.Modulo.includes(Modulos.INTEGRACION_OCR)).map(x => x.id)
    },
    ierpStates: function () {
      return this.tiposEstado.filter(x => x.Modulo.includes(Modulos.INTEGRACION_ERP)).map(x => x.id)
    },
    ipgeStates: function () {
      return this.tiposEstado.filter(x => x.Modulo.includes(Modulos.AUTO_FACTURA)).map(x => x.id)
    },
    userGroups: function () {
      return this.$store.getters['auth/user']?.Grupos
    },
    hasAllPropietariosByGroups () {
      return [3, 8].includes(this.role) || (this.userGroups.some(y => y.idGrupo === this.form.idGrupoPropietario || y.idTipo === 1) && this.form.esPropietario)
    },
    hasTBAIInformation () {
      return this.form.idTicketBai || this.form.fechaTicketbai || this.form.estadoTicketbai
    },
    hasWorkflowInformation () {
      return this.form.FlujoAprobacionFacturaInfo !== null
    },
    hasFormEdits () {
      return Object.values(this.formEditMode).some(Boolean)
    },
    isTurnWorkflow () {
      return this.form.FlujoAprobacionFacturaInfo?.EsTurnoUsuario
    },
    hasVerifactuInformation () {
      return !!this.form.urlVerifactu
    },
    hasModuleGeneratePaymentLink: function () {
      return !!this.$store.getters['auth/hasGeneratePaymentLinkModule']
    },
    showDeleteColumn: function () {
      return this.idEstado === 0 && this.form.Adjuntos.some(x => x.idRelatedDocument !== 0 && x.Relacionado === false) && this.showInvoiceActions
    },
    showAddImporteButton: function () {
      // Mostrar el botón "+" cuando no hay filas o cuando la última está completa.
      const list = this.form.importesMod
      if (list.length === 0) return true
      const last = list[list.length - 1]
      return [last.Clase, last.Base, last.Tipo, last.Importe].every(v => v !== '' && v !== null && v !== undefined)
    },
  },
  created: function () {
    this.setupFormEditModeWatchers()
    this.reloadInvoice()
  },
  methods: {
    // toggleEditMode () {
    //   if (!this.showEditModeOCRIA) {
    //     this.resetFormEditMode()
    //   } else {
    //     this.preLoadDataForLists()
    //   }
    // },
    preLoadDataForLists: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        // Cargamos los tipos de impuestos para el select de importes
        const response = await getImpuestosSimple({ idCliente: this.form.idCliente })
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          // Guardamos también TaxType para poder autoasignar la Clase al cambiar el Tipo.
          const listImpuestos = response.Respuesta.map(x => ({ label: x.TaxRate + '% - ' + x.Name, value: x.TaxRate, TaxType: x.TaxType }))
          // Añade los Tipo actuales de importesMod que no estén en el catálogo para no perder el valor seleccionado
          const importesActuales = this.form.importesMod || []
          importesActuales.forEach(item => {
            const tipo = item.Tipo
            // Tipos impositivos NO válidos (0 sí es válido)
            if (tipo === '' || tipo === null || tipo === undefined) return
            if (!listImpuestos.some(x => String(x.value) === String(tipo))) {
              listImpuestos.push({ label: tipo + '% - ' + i18n.t('invoices.tax_rate_undefined'), value: tipo })
            }
          })
          this.tiposImpuestos = listImpuestos
        }

        // * De momento lo dejamos nombre y CIF
        // Cargamos los CIF de los emisores para el select de CIF Emisor 
        // const response = await getImpuestosSimple({ idCliente: this.form.idCliente })
        // if (!response.blnError) {
        //   this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        // } else {
        //   this.tiposImpuestos = response.Respuesta
        // }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    resetFormEditMode () {
      this.suppressEditWatchers = true
      Object.keys(this.formEditMode).forEach(key => {
        this.formEditMode[key] = false
      })
      // Restaura los backing fields "Mod" al valor de su campo original homónimo.
      this.form.numFacturaMod = this.form.numFactura
      this.form.SerieFacturaMod = this.form.SerieFactura
      this.form.NombreCIFEmisorMod = this.form.NombreCIFEmisor
      this.form.cifEmisorMod = this.form.cifEmisor

      // Inversa de i18n.d(value, 'numeric_date', { date: '-' }) => parsea 'DD-MM-YYYY' a Date.
      this.form.fechaFacturaMod = this.form.fechaFactura
        ? moment(this.form.fechaFactura, 'DD-MM-YYYY').toDate()
        : null
      // Inversa de i18n.n(value, 'currency') en locale con grouping '.' y decimal ',' (es/eu/ca/gl/de/fr).
      const importeStr = String(this.form.importe ?? '')
        .replace(/\s/g, '')
        .replace(/\./g, '')
        .replace(',', '.')
      const importeNum = parseFloat(importeStr)
      this.form.importeMod = isNaN(importeNum) ? null : importeNum

      // Copia para no compartir referencias
      this.form.importesMod = (this.form.importes || []).map(x => ({ ...x }))
      this.captureEditBaseline()
      this.$nextTick(() => {
        this.suppressEditWatchers = false
      })
    },
    addImporte () {
      this.form.importesMod.push({ Clase: '', Base: '', Tipo: '', Importe: '' })
    },
    removeImporte (index) {
      this.form.importesMod.splice(index, 1)
    },
    getImpuestoName (clase) {
      if (clase === '' || clase === null || clase === undefined) return ''
      return this.tiposCodigoImpuesto.find(x => x.id === String(clase))?.name ?? clase
    },
    getTipoLabel (tipo) {
      if (tipo === '' || tipo === null || tipo === undefined) return ''
      return this.tiposImpuestos.find(x => String(x.value) === String(tipo))?.label ?? String(tipo)
    },
    // Devuelve el impuesto del catálogo (getImpuestosSimple) cuyo TaxRate coincide
    findImpuestoByTipo (tipo) {
      if (tipo === '' || tipo === null || tipo === undefined) return null
      return this.tiposImpuestos.find(x => x.TaxType != null && String(x.value) === String(tipo)) || null
    },
    // Si el nuevo Tipo tiene match en el catálogo, propaga su TaxType a Clase.
    // Si no hay match, deja la Clase actual para que el usuario pueda elegirla.
    onTipoImpuestoChange (index) {
      const row = this.form.importesMod[index]
      if (!row) return
      const match = this.findImpuestoByTipo(row.Tipo)
      if (match) {
        row.Clase = match.TaxType
      }
    },
    // Clase editable solo cuando el Tipo actual no coincide con ningún impuesto
    // del catálogo; en caso contrario se muestra el match y queda deshabilitado.
    isClaseEditable (index) {
      const row = this.form.importesMod[index]
      if (!row) return true
      return !this.findImpuestoByTipo(row.Tipo)
    },
    setupFormEditModeWatchers () {
      Object.keys(this.formEditMode).forEach(key => {
        // Si el campo tiene una versión "Mod" (backing field usado para edición
        // cuando el valor original está formateado), observamos esa. Si no, el propio campo.
        const hasMod = Object.prototype.hasOwnProperty.call(this.form, `${key}Mod`)
        const path = hasMod ? `form.${key}Mod` : `form.${key}`
        const target = hasMod ? this.form[`${key}Mod`] : this.form[key]
        // Los arrays/objetos requieren watch profundo para detectar cambios en sus elementos.
        const deep = Array.isArray(target)
        this.$watch(path, (value) => {
          if (!this.showEditModeOCRIA || this.suppressEditWatchers) return
          this.formEditMode[key] = this.normalizeEditValue(value) !== this.editBaseline[key]
        }, { deep })
      })
    },
    captureEditBaseline () {
      this.editBaseline = Object.keys(this.formEditMode).reduce((acc, key) => {
        const hasMod = Object.prototype.hasOwnProperty.call(this.form, `${key}Mod`)
        acc[key] = this.normalizeEditValue(hasMod ? this.form[`${key}Mod`] : this.form[key])
        return acc
      }, {})
    },
    normalizeEditValue (value) {
      if (value === null || value === undefined) return ''
      if (value instanceof Date) return moment(value).format('YYYY-MM-DD')
      if (Array.isArray(value)) {
        return JSON.stringify(value.map(row =>
          [row.Clase, row.Base, row.Tipo, row.Importe].map(v => this.normalizeEditValue(v))
        ))
      }
      if (typeof value === 'number') return String(value)
      const str = String(value).trim()
      if (str !== '' && !isNaN(Number(str))) return String(Number(str))
      if (/^\d{4}-\d{2}-\d{2}/.test(str)) return moment(str).format('YYYY-MM-DD')
      return str
    },
    reloadInvoice: async function () {
      this.invoiceActions = []
      this.filterByParamsData()

      await this.downloadInvoiceData()

      this.header.url = this.routeBack

      const breadcrumbs = []
      var invoiceType = this.form.EsRecibida ? 'received' : 'issued'
      breadcrumbs.push({ path: `invoices${invoiceType}`, name: i18n.t(`invoices.${invoiceType}_header`) })
      breadcrumbs.push({ path: `/invoices${invoiceType}/${this.idEstado}`, name: this.form.Estado })
      const asuntoBreadCrumb = this.form.numFactura
      breadcrumbs.push({ path: '', name: this.truncate(asuntoBreadCrumb, 30, false) })
      this.$store.commit('app/setheaderBreadCrumb', { NumFactura: asuntoBreadCrumb, idEstado: this.idEstado, NombreEstado: this.form.Estado })
      this.header.breadcrumb = breadcrumbs

      // Añadimos Acciones
      const acciones = this.$store.getters['app/actionsForSelect'](this.idEstado, this.form.EsRecibida ? 'Recibida' : 'Emitida')
      if (acciones && (this.role === 3 || this.hasAllPropietariosByGroups)) {
        let avaliableActions = acciones.Acciones.concat(this.listaAccionesUsuarioCliente)
        // Eliminamos consulta para pge externo
        if (this.pgeType === 'EXTERNO') avaliableActions = avaliableActions.filter(x => x.IdAccion !== 12)
        // Eliminamos borrar para rol Usuario
        if (this.role === 1) avaliableActions = avaliableActions.filter(x => x.IdAccion !== 3)
        else if (this.role === 4) avaliableActions = []
      
        this.invoiceActions = this.filterStatesByModules(avaliableActions)

        if (this.form.OrigenFactura === 'EMISION') {
          this.genearateRecurrenceActions(this.form.EstadoRecurrencia)
        }
      }
      if (this.hasWorkflowInformation && this.hasModuleWorkflow && this.idEstado === 19) {
        this.generateAccionesWorkflow()
      }
      
      if (this.showEditModeOCRIA) {
        this.preLoadDataForLists()
      }
    },
    disabledDate: function (date) {
      const dateMoment = moment(date)
      return !dateMoment.isBetween(moment(this.form.fechaFactura, 'DD-MM-YYYY', true), moment(), 'day', '[]')
    },
    filterStatesByModules (actions) {
      if (!this.hasIERPModule && this.form.idEstado === 19) {
        actions = actions.filter(tAction => !this.tiposAccion.filter(module => module.Modulo.includes(Modulos.INTEGRACION_ERP)).map(map => map.id).includes(tAction.IdAccion))
      }
      if (!this.hasModuleGeneratePaymentLink || ![0, 1, 2, 3, 4, 5].includes(this.form.idEstado)) {
        actions = actions.filter(tAction => !this.tiposAccion.filter(module => module.Modulo.includes(Modulos.GENERATE_PAYMENT_LINK)).map(map => map.id).includes(tAction.IdAccion))
      }
      return actions
    },
    pdfViewerOpenHandler () {
      this.actualFilterContent = null
    },
    filterByParamsData () {
      const data = this.$route.params.data
      if (data) {
        data.filters.forEach(filter => {
          if (filter.type === 'contenido') {
            this.actualFilterContent = filter.data
          }
        })
      }
    },
    applyNewWhiteMailDialog: async function (form) {
      if (form.GestionarListaBlancaGrupos) {
        this.auxGroupsMail = {
          valueTo: form.valueTo,
          valueCC: form.valueCC,
          valueCCO: form.valueCCO,
          TextoCorreo: form.TextoCorreo,
          AsuntoCorreo: form.AsuntoCorreo,
        }
        this.linkMyGroupsToggleDialog()
      } else {
        this.newWhiteMailDialogHandler(form)
      }
      this.showModalWhiteMail = false
    },
    /*     applyLinkMyGroupsDialog (grupos) {
      this.newWhiteMailDialogHandler(this.auxGroupsMail, grupos)
    }, */
    newWhiteMailDialogHandler: async function (emails, grupos) {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = { 
          Emails: emails.valueTo.split(';').map(x => x.trim()).filter(x => !!x), 
          EmailsCC: emails.valueCC.split(';').map(x => x.trim()).filter(x => !!x), 
          EmailsCCO: emails.valueCCO.split(';').map(x => x.trim()).filter(x => !!x), 
          listaIDs: [{ IdFacturae: this.idFacturae, IdInvoice: this.idInvoice }],
          idGrupos: grupos || null,
          TextoCorreo: emails.TextoCorreo || null,
          AsuntoCorreo: emails.AsuntoCorreo || null,
        }
        const endpoint = this.selectedAction.IdAccion === 300 ? enviarCobroEmail : sendAvisoCorreoManual
        const response = await endpoint(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.showModalLinkMyGroups = false
        }
      } catch (error) {
        console.error(error)
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        this.data = await this.downloadInvoiceData()
      }
    },
    goBack: function () {
      this.$router.push({ name: this.header.url })
    },
    copyLinkDownload: function () {
      const url = process.env.VUE_APP_API_URL + this.form.enlaceDescarga

      navigator.clipboard.writeText(url)

      this.$message({
        type: 'success',
        message: i18n.t('feedback.success.download_link_copied_msg')
      })
    },
    selectActionIcon: function (action) {
      var icon = ''
      switch (action.IdAccion) {
        case 1:
          icon = 'export'
          break
        case 3:
          icon = 'trash'
          break
        case 5:
          icon = 'registrar'
          break
        case 6:
          icon = 'aceptar'
          break
        case 7:
          icon = 'contabilizar'
          break
        case 8:
          icon = 'rechazar'
          break
        case 9:
          icon = 'pagar'
          break
        case 10:
          icon = 'anular'
          break
        case 11:
          icon = 'pasarerror'
          break
        case 12:
          icon = 'consultar'
          break
        case 19:
          icon = 'rectificar'
          break
        case 20:
          icon = 'acceptpresupuesto'
          break
        case 21:
          icon = 'cancelproforma'
          break
        case 22:
          icon = 'convertproforma'
          break
        case 23:
          icon = 'cancelproforma'
          break
        case 24:
          icon = 'facturar'
          break
        case 25:
          icon = 'mailsend'
          break
        case 100:
          icon = 'groupadd' // Manual
          break
        case 101:
          icon = 'groupremove' // Manual
          break
        case 102:
          icon = 'groupchange' // Manual
          break
        case 200:
          icon = 'download'
          break
        case 300:
          icon = 'maileurosend'
          break
        case 301:
          icon = 'rechazar'
          break
        case 302:
          icon = 'groupchange'
          break
        case 303:
          icon = 'check'
          break
        case 304:
          icon = 'send-inmatic'
          break
        default:
          icon = 'changestatus'
          break
      }
      return icon
    },
    toggleDialogs: function () {
      this.showNewDocument = !this.showNewDocument
    },
    toggleDialogAttachment () {
      this.showNewAttachment = !this.showNewAttachment
    },
    newWhiteMailToggleDialog () {
      this.showModalWhiteMail = !this.showModalWhiteMail
    },
    linkMyGroupsToggleDialog () {
      this.showModalLinkMyGroups = !this.showModalLinkMyGroups
    },
    applyDialogHandler: async function () {
      await this.downloadInvoiceData()
    },
    applyDialogAttachmentHandler: async function () {
      await this.downloadInvoiceData()
    },
    validateInvoiceForm: async function (formName) {
      if (this.showEditModeOCRIA && (!this.form.importesMod || this.form.importesMod.length === 0)) {
        this.doFeedback(i18n.t('invoices.one_importe_required'))
        return false
      }
      // validate() sin callback devuelve una promesa (Element UI): rechaza si el form es inválido
      const valid = await this.$refs[formName].validate().catch(() => false)
      if (!valid) {
        this.doFeedback(i18n.t('feedback.error.process_data_error'))
        return false
      }
      return true
    },
    submitForm: async function (formName, { idDecision = null, comentario = null, IdNuevoFlujoAprobacion = null, reload = true } = {}) {
      const isEditable = this.showEditModeOCRIA
      // Reasignar sin editar no marca la factura como revisada
      const sendEdicion = isEditable && (idDecision !== 3 || this.hasFormEdits)
      if (sendEdicion || !isEditable) {
        const isValid = await this.validateInvoiceForm(formName)
        if (!isValid) {
          return false
        }
      }
      if (!isEditable) {
        this.$store.commit('setAjaxRequestPending', true)
      }
      this.$store.commit('setIsLoading', true)
      try {
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          notas: this.form.full_text,
        }
        const data = isEditable ? {
          edicionFactura: sendEdicion ? {
            NumFactura: this.form.numFacturaMod,
            SerieFactura: this.form.SerieFacturaMod,
            NombreCIFEmisor: this.form.NombreCIFEmisorMod,
            CIFEmisor: this.form.cifEmisorMod,
            FechaFactura: this.form.fechaFacturaMod ? moment(this.form.fechaFacturaMod).format('YYYY-MM-DD') : null,
            Importe: this.form.importeMod,
            Importes: this.form.importesMod,
          } : null,
          datosFlujo: idDecision ? {
            idTipoDecision: idDecision,
            IdNuevoFlujoAprobacion: IdNuevoFlujoAprobacion,
            Comentario: comentario,
          } : null,
        } : null
        if ([7, 18].includes(this.idEstado) && this.showInvoiceActions && this.form.FechaPago !== i18n.d(this.form.FechaPagoMod, 'numeric_date', { date: '-' })) {
          params.FechaPago = this.form.FechaPagoMod
        }
        const response = await updateFactura(params, data)
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          return false
        }
        this.doFeedback(i18n.t(idDecision ? 'feedback.success.action_tramited_msg' : 'feedback.success.saved_data_msg'), 'success')
        if (isEditable && reload) {
          this.resetFormEditMode()
          this.reloadInvoice()
        }
        return true
      } catch (error) {
        this.doFeedback()
        return false
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    downloadInvoiceData: async function () {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idInvoice: this.idInvoice,
          idFacturae: this.idFacturae,
        }
        await this.downloadInvoiceDataMetadata(params)
        const prioritario = await this.getDocPrioritario(params)
        const file = this.form.Adjuntos.find(x => x.idRelatedDocument === prioritario.IdDocumentoRelacionado)
        if (file.idRelatedDocument === 0 && (file.Extension.toLocaleLowerCase() === 'xml' || file.Extension.toLocaleLowerCase() === 'xsig')) {
          this.downloadInvoiceDataXHTML(params)
        } else if (file.Extension.toLocaleLowerCase() === 'xml' || file.Extension.toLocaleLowerCase() === 'xsig') {
          this.showEmbedXml(file)
        } else {
          this.showAdjunto(file, true)
        }
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    downloadInvoiceDataMetadata: async function (params) {
      try {
        const invoice = await getInvoice(params)
        if (invoice.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', invoice))
          return
        }
        this.setInvoice(invoice.respuesta)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    toggleWorkflowDialog (action) {
      if (this.showModalWorkflow) {
        this.workflowAction = null
        this.headerWorkflow = null
        return
      } 
      this.workflowAction = action.IdAccion
      this.headerWorkflow = action.Descripcion
      this.showModalWorkflow = !this.showModalWorkflow
    },
    applyWorkflowHandler: async function (workflowForm) {
      switch (workflowForm.action) {
        case 303: 
        case 301: 
          await this.approveRejectWorkflowHandler(workflowForm)
          break
        case 302:
          await this.reasignWorkflowHandler(workflowForm)
          break
      }
    },
    approveRejectWorkflowHandler: async function (form) {
      this.$store.commit('setIsLoading', true)
      let success = false
      try {
        if (this.showEditModeOCRIA) {
          const idDecision = this.accionesFlujo.find(a => a.id === form.action)?.idDecision
          success = await this.submitForm(
            'ruleForm', 
            { idDecision, comentario: form.Comentario, reload: false }
          )
        } else {
          const payload = [
            {
              IdFacturae: this.idFacturae,
              IdInvoice: this.idInvoice,
              IdUsuario: this.userId,
              Comentario: form.Comentario
            }
          ]
          const response = form.action === 303 ? await aceptarWorkflow(payload) : await rechazarWorkflow(payload)
          if (response && response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
            success = true
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        // Si el guardado en modo edición falló, no recargamos para conservar las correcciones del usuario
        if (success || !this.showEditModeOCRIA) {
          this.reloadInvoice()
          bus.$emit('changeIt', 'changed menu')
        }
      }
    },
    reasignWorkflowHandler: async function (form) {
      this.showModalWorkflow = false
      this.$store.commit('setIsLoading', true)
      let success = false
      try {
        if (this.showEditModeOCRIA) {
          const idDecision = this.accionesFlujo.find(a => a.id === form.action)?.idDecision
          success = await this.submitForm(
            'ruleForm', 
            { idDecision, comentario: form.Comentario, IdNuevoFlujoAprobacion: form.newWorkflow, reload: false }
          )
        } else {
          const payload = [
            {
              IdFacturae: this.idFacturae,
              IdInvoice: this.idInvoice,
              IdUsuario: this.userId,
              IdNuevoFlujoAprobacion: form.newWorkflow,
              Comentario: form.Comentario
            }
          ]
          const response = await reasignarWorkflow(payload)
          if (response && response.blnError === true) {
            this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          } else {
            this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
            success = true
          }
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
        // Si el guardado en modo edición falló, no recargamos para conservar las correcciones del usuario
        if (success || !this.showEditModeOCRIA) {
          this.reloadInvoice()
          bus.$emit('changeIt', 'changed menu')
        }
      }
    },
    getDocPrioritario: async function (params) {
      try {
        const response = await getDocumentoPrioritario(params)
        if (response.blnError) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
          return
        }
        return response.Respuesta
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    getScrollBarsStyle: function () {
      const computedStyle = getComputedStyle(document.documentElement)
      const variableNames = ['--primary-400', '--primary-500', '--Component-background-']
      const rootStyle = variableNames.map(x => `${x}: ${computedStyle.getPropertyValue(x)}`).join('; ')
      return `:root { ${rootStyle} } ::-webkit-scrollbar { width: 8px; height: 8px; } ::-webkit-scrollbar-thumb { background-color: var(--primary-400); border-radius: 20px; } ::-webkit-scrollbar-corner { background: var(--Component-background-); } ::-webkit-scrollbar-thumb:hover { background: var(--primary-500); } ::-webkit-scrollbar-button { height: 2px; width: 2px; }`
    },
    downloadInvoiceDataXHTML: async function (params) {
      try {
        const htmlxslt = await getXHTMLFactura(params)
        if (htmlxslt.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', htmlxslt))
        } else {
          this.form.contentHhtmlXslt = htmlxslt.Respuesta
          this.showXhtml = true
          this.showPdf = false
          this.showImage = false
          this.showXml = false
          this.insertIframeContent()
        }
        // this.mountScript(htmlxslt.Respuesta)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      }
    },
    insertIframeContent () {
      let iframe = document.getElementById('container-xhtml-iframe')

      if (iframe) {
        iframe.addEventListener('load', () => {
          const doc = iframe?.contentDocument || iframe?.document || iframe
          const style = doc.createElement('style')
          style.textContent = this.getScrollBarsStyle()
          style.textContent += '.page { padding: 15mm; } @media not print { html { max-height: 100%; } body { width: 210mm; height: 297mm; overflow-x: hidden; } body { transform-origin: top left; transform: scale(calc(100vw / 210mm)); } }'
          doc.head.appendChild(style)
        })
        iframe = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
  
        iframe.document.open()
        iframe.document.write(this.form.contentHhtmlXslt)
        iframe.document.close()
      }
    },
    mountScript (xhtml) {
      // Eliminamos script si existe
      const id = 'scriptxhtmlcustom'
      try {
        this.removeElement(id)
      } catch (error) {
      }

      // Extraemos nuevo script del xhtml
      const result = xhtml.match(/(?<=<script>\s*).*?(?=\s*<\/script>)/gs) // Returns multiple matches if any
      const scriptXhtml = document.createElement('script')
      scriptXhtml.id = id
      scriptXhtml.innerHTML = result[0]

      // Insertamos script
      document.head.appendChild(scriptXhtml)
    },
    removeElement (id) {
      const elem = document.getElementById(id)
      elem.parentNode.removeChild(elem)
    },
    setInvoice: function (invoice) {
      this.suppressEditWatchers = true
      this.invoice = invoice
      this.form.EsRecibida = invoice.EsRecibida
      this.form.fechaFactura = i18n.d(invoice.FechaFactura, 'numeric_date', { date: '-' })
      this.form.idEstado = invoice.idEstado
      this.form.Estado = this.tiposEstado.find(x => x.id === this.form.idEstado)?.Nombre ?? invoice.idEstado 
      this.form.tipoInvoiceClass = invoice.TipoInvoiceClass
      this.form.numFactura = invoice.NumFactura
      this.form.SerieFactura = invoice.SerieFactura && invoice.SerieFactura !== '' ? invoice.SerieFactura : ' '
      this.form.Empresa = invoice.NombreCliente
      this.form.NombreCIFReceptor = invoice.NombreCIFReceptor
      this.form.cifReceptor = invoice.CIFReceptor
      this.form.NombreCIFEmisor = invoice.NombreCIFEmisor
      this.form.cifEmisor = invoice.CIFEmisor
      this.form.importe = i18n.n(invoice.Importe, 'currency')
      this.form.idCliente = invoice.idCliente
      this.form.full_text = invoice.Notas
      this.form.tipoFactura = invoice.Tipo
      this.form.enlaceDescarga = invoice.EnlaceDescarga
      this.form.importes = invoice.Importes || []
      this.form.csv = invoice.Csv
      this.form.NumAsiento = invoice.NumAsiento
      this.form.FechaEntradaERP = invoice.FechaEntradaERP ? i18n.d(invoice.FechaEntradaERP, 'numeric_date', { date: '-' }) : null
      this.form.FechaAlta = invoice.FechaAlta ? i18n.d(invoice.FechaAlta, 'numeric_date', { date: '-' }) : null
      this.form.FechaPago = invoice.FechaPago ? i18n.d(invoice.FechaPago, 'numeric_date', { date: '-' }) : null
      this.form.FechaRechazo = invoice.FechaRechazo ? i18n.d(invoice.FechaRechazo, 'numeric_date', { date: '-' }) : null
      this.form.UltimoError = invoice.UltimoError
      this.form.MotivoRechazo = invoice.MotivoRechazo
      this.form.pgeType = invoice.Pge
      this.form.EsOCREditable = invoice.EsOCREditable
      this.form.pgeTypeName = this.pgeTypes.filter(x => x.id === invoice.Pge)[0]?.name ?? invoice.Pge
      this.form.idGrupoPropietario = invoice.GrupoPropietario.idGrupo
      this.form.fechaTicketbaiRegistro = invoice.ResultadosEnvioTBAI?.HoraRegistro ? i18n.d(invoice.ResultadosEnvioTBAI?.HoraRegistro, 'numeric_datetime', { date: '-', datetime: ' ' }) : null
      this.form.fechaTicketbaiEnvio = invoice.ResultadosEnvioTBAI?.HoraEnvio ? i18n.d(invoice.ResultadosEnvioTBAI?.HoraEnvio, 'numeric_datetime', { date: '-', datetime: ' ' }) : null
      this.form.IdTBAI = invoice.IdTBAI
      this.form.estadoTicketbai = this.tiposEstadoTBAI.filter(x => parseInt(x.value) === invoice.ResultadosEnvioTBAI?.idEstadoTBAI)[0]?.label ?? invoice.ResultadosEnvioTBAI?.idEstado
      this.form.Hacienda = this.tiposHacienda.filter(x => parseInt(x.value) === invoice.ResultadosEnvioTBAI?.Hacienda)[0]?.label ?? invoice.ResultadosEnvioTBAI?.Hacienda
      this.form.urlHacienda = invoice.ResultadosEnvioTBAI?.URLTBAI ?? ''
      this.form.CSVEnvioTBAI = invoice.ResultadosEnvioTBAI?.CSVEnvioTBAI ?? ''
      this.form.ResultadosValidacion = invoice.ResultadosEnvioTBAI?.ResultadosValidacion ?? ''
      this.form.urlVerifactu = invoice.URLVerifactu

      this.form.CsvAEAT = invoice.RegistroResponse?.CsvAEAT ?? ''
      this.form.NumSerieFact = invoice.RegistroResponse?.NumSerieFact ?? ''
      this.form.IdNifEmpresa = invoice.RegistroResponse?.IdNifEmpresa ?? ''
      this.form.CSVVerifactuZC = invoice.RegistroResponse?.CSVVerifactuZC ?? ''
      this.form.FechaExpedicion = invoice.RegistroResponse?.FechaExpedicion ?? ''
      this.form.IdEstadoVerifactu = invoice.RegistroResponse?.IdEstadoVerifactu ?? ''

      this.form.OrigenFactura = invoice.OrigenFactura ?? ''
      this.form.EstadoRecurrencia = invoice.EstadoRecurrencia
      this.editRecurrencia = invoice.EstadoRecurrencia
      this.form.idFacturaRecurrente = invoice.IdFacturaRecurrente ?? ''

      this.form.idEstadoRelacionado = invoice.idEstadoRelacionado ?? ''
      this.form.idFacturaeRelacionado = invoice.idFacturaeRelacionado ?? ''
      this.form.idInvoiceRelacionado = invoice.idInvoiceRelacionado ?? ''

      this.form.FlujoAprobacionFacturaInfo = invoice.FlujoAprobacionFacturaInfo ?? null

      // Formulario de validación por IA
      this.form.numFacturaMod = invoice.NumFactura
      this.form.SerieFacturaMod = invoice.SerieFactura && invoice.SerieFactura !== '' ? invoice.SerieFactura : ' '
      this.form.NombreCIFEmisorMod = invoice.NombreCIFEmisor
      this.form.cifEmisorMod = invoice.CIFEmisor
      this.form.fechaFacturaMod = invoice.FechaFactura || null
      this.form.importeMod = invoice.Importe ?? null
      // Copia profunda para no compartir referencia con this.form.importes ni con invoice.Importes.
      this.form.importesMod = (invoice.Importes || []).map(x => ({ ...x }))

      this.form.FacturaeFile = invoice.FacturaeFile || {
        idRelatedDocument: 0,
        Nombre: i18n.t('invoices.xml_file'),
        Extension: 'xml',
        Relacionado: false
      }

      this.form.Adjuntos = invoice.Adjuntos
      this.form.Adjuntos.forEach(x => this.$set(x, 'icon', 'eye')&this.$set(x, 'visible', false))
      // Añadimos fichero xml 
      this.form.Adjuntos.unshift({
        Extension: this.form.FacturaeFile.Extension,
        Nombre: this.form.FacturaeFile.Nombre,
        idRelatedDocument: this.form.FacturaeFile.idRelatedDocument,
        icon: 'eyeslash',
        visible: false,
        Relacionado: this.form.FacturaeFile.Relacionado
      })
      this.form.DocumentosRelacionados = invoice.FicherosRelacionados
      this.form.DocumentosRelacionados.forEach(x => this.$set(x, 'icon', 'eye')&this.$set(x, 'visible', false))

      if (invoice.MetadatosAdicionales !== undefined) {
        this.form.Metadatos = invoice.MetadatosAdicionales
          .filter((x) => x.Valor !== '' && x.Campo !== 'XmlNotificacion')
          .sort((a, b) => {
            if (a.Campo < b.Campo) return -1
            if (a.Campo > b.Campo) return 1
            return 0
          })
      }

      this.form.esPropietario = invoice.EsPropietario
      this.resetDocumentsSelected()

      Object.keys(this.formEditMode).forEach(key => {
        this.formEditMode[key] = false
      })
      this.captureEditBaseline()
      this.$nextTick(() => {
        this.suppressEditWatchers = false
      })
    },
    newDocument: async function () {
      this.toggleDialogs()
    },
    newAttachment: async function () {
      this.toggleDialogAttachment()
    },
    deleteAdjunto: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: row.idRelatedDocument,
        }
        const response = await eliminarAdjunto(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.attachment_deleted_msg'), 'success')
          await this.downloadInvoiceData()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    deleteDocRel: async function (row) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: row.idRelatedDocument,
        }
        const response = await eliminarDocRel(params)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.document_deleted_msg'), 'success')
          await this.downloadInvoiceData()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    resetDocumentsSelected: async function (rowException = null) {
      if (this.form.DocumentosRelacionados) {
        this.form.DocumentosRelacionados.forEach(key => {
          // Resetea si no es el actual
          if (!rowException || !(rowException.docRel && rowException.idRelatedDocument === key.idRelatedDocument)) {
            this.resetRowName(key)
            key.visible = false
            key.icon = key.Extension.trim().toUpperCase() === 'PDF' || key.Extension.trim().toUpperCase() === 'PNG' ? 'eye' : 'download'
          }
        })
      }
      this.form.Adjuntos.forEach(key => {
        // Resetea si no es el actual
        if (!rowException || !(!rowException.docRel && rowException.idRelatedDocument === key.idRelatedDocument)) {
          key.visible = false
          if (key.idRelatedDocument === 0 && key.Extension.trim().toUpperCase() === 'XML') {
            key.icon = 'eye'
            key.tipo = 'xml'
          } else {
            key.icon = key.Extension.trim().toUpperCase() === 'PDF' || key.Extension.trim().toUpperCase() === 'PNG' ? 'eye' : 'download'
            key.tipo = key.Relacionado ? 'xmlembed' : (icons.includes(key.Extension.trim().toLowerCase()) ? key.Extension.trim().toLowerCase() : null)
          }
        }
      })
    },
    showAdjunto: async function (row, withoutEvent) {
      const docRel = false
      const exceptionDocument = {
        docRel,
        idRelatedDocument: row.idRelatedDocument,
      }
      await this.resetDocumentsSelected(exceptionDocument)
      // Documento facturae (documento xml de la factura)
      if (row.idRelatedDocument === 0 && row.Extension.trim().toUpperCase() === 'XML') {
        if (!this.form.contentHhtmlXslt) {
          const params = {
            idInvoice: this.idInvoice,
            idFacturae: this.idFacturae,
          }
          this.downloadInvoiceDataXHTML(params)
        }
        this.showPdf = false
        this.showImage = false
        this.showXml = false
        if (row.icon === 'eye') {
          this.showXhtml = true
          row.visible = true
          row.icon = 'eyeslash'
        } else {
          this.showXhtml = false
          row.icon = 'eye'
        }
        this.resetRowName(row)
      } else {
        if (row.Extension.trim().toUpperCase() === 'PDF') {
          this.showXhtml = false
          this.showImage = false
          this.showXml = false
          if (row.icon === 'eye') {
            row.icon = 'eyeslash'
            row.visible = true
            this.showPdf = true
          } else {
            row.icon = 'eye'
            this.showPdf = false
          }
          this.resetRowName(row)
          await this.showPDFHandler(row, withoutEvent, docRel)
        } else {
          await this.downloadAdjunto(row, docRel)
        }
      }
    },
    showDocRel: async function (row, withoutEvent) {
      const docRel = true
      const exceptionDocument = {
        docRel,
        idRelatedDocument: row.idRelatedDocument,
      }
      await this.resetDocumentsSelected(exceptionDocument)
      if (row.Extension.trim().toUpperCase() === 'PDF') {
        this.showXhtml = false
        this.showImage = false
        this.showXml = false
        await this.showPDFHandler(row, withoutEvent, docRel)
        if (row.icon === 'eye') {
          row.icon = 'eyeslash'
          this.showPdf = true
        } else {
          row.icon = 'eye'
          this.showPdf = false
        }
        this.resetRowName(row)
      } else if (row.Extension.trim().toUpperCase() === 'PNG') {
        this.showXhtml = false
        this.showPdf = false
        this.showXml = false
        await this.showImageVisor(row, withoutEvent)
        if (row.icon === 'eye') {
          row.icon = 'eyeslash'
          this.showImage = true
        } else {
          row.icon = 'eye'
          this.showImage = false
        }
        this.resetRowName(row)
      } else {
        await this.downloadAdjunto(row, docRel)
      }
    },
    showImageVisor: async function (row, withoutEvent) {
      this.$store.commit('app/setLoading', true)
      const params = {
        idFacturae: this.idFacturae,
        idInvoice: this.idInvoice,
        idRelatedDocument: row.idRelatedDocument,
        automatico: withoutEvent
      }
      const response = await descargarDocRel(params)
      const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
      this.showPdf = false
      this.showXhtml = false
      this.showXml = false
      this.showImage = true
      this.srcImage = window.URL.createObjectURL(blob)
      this.imageFilename = decodeURI(row.Nombre)
    },
    showEmbedXml: async function (row, docRel = false) {
      const exceptionDocument = {
        docRel: docRel,
        idRelatedDocument: row.idRelatedDocument,
      }
      await this.resetDocumentsSelected(exceptionDocument)
      this.showImage = false
      this.showXhtml = false
      this.showPdf = false
      if (row.idRelatedDocument === 0 && row.Extension.trim().toUpperCase() === 'XML') {
        row.icon = 'eye'
        this.resetRowName(row)
      }
      if (!this.showXml || !row.visible) {
        if (row.Extension.trim().toUpperCase() === 'XML') {
          const xmlString = await this.getXml(row, docRel)
          if (typeof xmlString === 'string') {
            row.visible = true
            this.showXml = true 
            await this.showTextEditorXml(xmlString)
          }
          this.resetRowName(row)
        }
      } else {
        this.showXml = false
        row.visible = false
      }
    },
    showTextEditorXml: async function (xmlString) {
      this.$store.commit('setIsLoading', true)
      this.showXml = true
      this.showImage = false
      this.showXhtml = false
      this.showPdf = false

      this.xmlData = this.escapeUsingDOM(xmlString).replaceAll('&lt;', '<').replaceAll('&gt;', '>')

      this.$store.commit('setIsLoading', false)
    },
    getXml: async function (row, docRel = false) {
      try {
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: row.idRelatedDocument,
          automatico: true
        }
        this.$store.commit('app/setLoading', true)
        let response
        if (params.idRelatedDocument === 0) {
          response = await getDocFactura(params)
        } else {
          if (!docRel) {
            response = await getAdjunto(params)
          } else {
            response = await getDocRel(params)
          }
        }
        return response
      } catch (error) {
        this.doFeedback(error)
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    escapeUsingDOM: function (str) {
      const div = document.createElement('div')
      div.textContent = str
      return div.innerHTML
    },
    resetRowName (row) {
      // Tmp update icon
      const auxNombre = row.Nombre
      row.Nombre = auxNombre + ' '
      setTimeout(() => {
        row.Nombre = auxNombre
      }, 50)
    },
    onDocumentErrored: function (e) {
      this.documentError = e.text
    },
    downloadAdjunto: async function (row, docRel = false) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: row.idRelatedDocument,
        }
        let response
        if (row.idRelatedDocument === 0) {
          response = await descargarDocFactura(params)
        } else {
          if (!docRel) {
            response = await descargarAdjunto(params)
          } else {
            response = await descargarDocRel(params)
          }
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })
        const link = document.createElement('a')
        link.href = window.URL.createObjectURL(blob)
        // const headerVal = response.headers['content-disposition']
        let filename = row.Nombre.trim() + '.' + row.Extension.trim()
        filename = decodeURI(filename)
        link.download = filename
        link.click()
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    printAdjunto: async function (row, docRel = false) {
      try {
        this.$store.commit('app/setLoading', true)
        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: row.idRelatedDocument,
        }
        let response
        if (row.idRelatedDocument === 0) {
          if (this.form.FacturaeFile.Extension.toLocaleLowerCase() === 'xml') {
            this.prettyPrintXML(params)
            return
          } else {
            response = await descargarDocFactura(params)
          }
        } else {
          if (!docRel) {
            response = await descargarAdjunto(params)
          } else {
            response = await descargarDocRel(params)
          }
        }
        const blob = new Blob([response.data], { type: response.data.type, encoding: 'UTF-8' })

        var iframe = document.getElementById('printeriframe')
        if (iframe) iframe.remove()
        iframe = document.createElement('iframe')
        iframe.setAttribute('id', 'printeriframe')
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        iframe.onload = function () {
          iframe.focus()
          iframe.contentWindow.print()
          // iframe.remove()
        }
        iframe.src = window.URL.createObjectURL(blob)
      } catch (error) {
        console.error(error)
        if (error.response?.data) {
          const errorText = await error.response.data.text()
          this.doFeedback(errorText)
        } else {
          this.doFeedback()
        }
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    prettyPrintXML: async function (params) {
      var response = await getXHTMLFactura(params)
      if (!response.blnError) {
        var iframe = document.getElementById('printeriframe')
        if (iframe) iframe.remove()
        iframe = document.createElement('iframe')
        iframe.setAttribute('id', 'printeriframe')
        iframe.style.display = 'none'
        document.body.appendChild(iframe)
        var iframeContent = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)

        iframeContent.document.open()
        iframeContent.document.write(response.Respuesta)
        iframeContent.document.close()
        var a = [...iframeContent.document.querySelectorAll('a[id $= Link]')]
        // TODO - ¿Se puede traducir en la plantilla de la API?
        a.filter(x => x.innerText === 'Mostrar más datos').forEach(x => iframeContent.mostrarCapa(x.id.substring(0, x.id.length - 'Link'.length)))
        iframeContent.print()
        iframe.remove()
      } else {
        this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
      }
    },
    printXMLView: function () {
      var iframe = document.getElementById('container-xhtml-iframe')
      var iframeContent = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
      iframeContent.print()
    },
    downloadXMLView: function () {
      this.doFeedback(new Error(i18n.t('feedback.error.feature_not_implemented')))
      // var iframe = document.getElementById('container-xhtml-iframe')
      // var iframeContent = iframe.contentWindow || (iframe.contentDocument.document || iframe.contentDocument)
      // var link = document.createElement('a')
      // link.href = `data:text/html;charset=UTF-8,${encodeURIComponent(iframeContent.document.documentElement.outerHTML)}`
      // var filename = this.form.FacturaeFile.Nombre.split('.')
      // link.download = `${[filename.slice(0, filename.length - 1)].join('.')}.html`
      // link.click()
    },
    showPDFHandler: async function (row, withoutEvent = false, docRel = false) {
      try {
        var idRelatedDocument = row.idRelatedDocument
        this.$store.commit('app/setLoading', true)

        const params = {
          idFacturae: this.idFacturae,
          idInvoice: this.idInvoice,
          idRelatedDocument: idRelatedDocument,
          automatico: withoutEvent
        }

        let adjunto
        if (idRelatedDocument === 0) {
          adjunto = await descargarDocFactura(params)
        } else if (!docRel) {
          adjunto = await descargarAdjunto(params)
        } else {
          adjunto = await descargarDocRel(params)
        }
        const blob = new Blob([adjunto.data], {
          type: 'application/pdf'
        })
        const url = URL.createObjectURL(blob)
        this.url = url
        this.viewerFilename = decodeURI(row.Nombre)
        // window.open(url)
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.download_file_error'))
      } finally {
        this.$store.commit('app/setLoading', false)
      }
    },
    truncate: function (str, n, useWordBoundary) {
      if (str.length <= n) { return str }
      const subString = str.substr(0, n - 1) // the original check
      return (useWordBoundary
        ? subString.substr(0, subString.lastIndexOf(' '))
        : subString) + '...'
    },
    showActionModal: async function (action) {
      this.selectedAction = action
      if (action.IdAccion === 3) { // Accion de Borrar utiliza dialogo
        this.showModalDelete = !this.showModalDelete
      } else if (action.IdAccion === 1) { // Accion de Descargar utiliza dialogo
        this.showModal = !this.showModal
      } else if (action.IdAccion === 19) { // Accion de Descargar utiliza dialogo
        this.showCorrectionModal = !this.showCorrectionModal
      } else if (action.IdAccion === 22 || action.IdAccion === 24) {
        this.toProforma = action.IdAccion === 22
        this.showProformaModal = !this.showProformaModal
      } else if (this.selectedAction.IdAccion === 25 || this.selectedAction.IdAccion === 300) { // Enviar aviso email a elección
        this.newWhiteMailToggleDialog()
      } else if (this.selectedAction.IdAccion === 26 || this.selectedAction.IdAccion === 27) { // Asignar recurrente || Editar recurrente
        this.showRecurrenceModal = !this.showCorrectionModal
      } else if (this.selectedAction.IdAccion === 28) { // Terminar recurrencia
        this.showModalDeleteRecurrence = true
      } else if (this.selectedAction.IdAccion === 303 || this.selectedAction.IdAccion === 301 || this.selectedAction.IdAccion === 302) { // Flujo aprobación
        if (this.showEditModeOCRIA && (action.IdAccion !== 302 || this.hasFormEdits)) {
          const isValid = await this.validateInvoiceForm('ruleForm')
          if (!isValid) return
        }
        this.toggleWorkflowDialog(action)
      } else if (this.selectedAction.IdAccion === 304) { // Enviar a Inmatic
        this.sendToInmatic()
      } else {
        this.submitAction()
      }
    },
    sendToInmatic: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const payload = {
          facturas: [{ idFacturae: this.idFacturae, idInvoice: this.idInvoice }],
          idCliente: null
        }
        if ([Roles.SuperAdminDistribuidor, Roles.SuperAdministrador].includes(this.role)) {
          payload.idCliente = this.form.idCliente
        }
        const response = await sendinvoizeinmatic(payload)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    showAction: function (action) {
      switch (action.IdAccion) {
        case 300:
          return this.hasModuleGeneratePaymentLink && [0, 1, 2, 3, 4, 5].includes(this.form.idEstado)
        case 304:
          return this.hasModuleInmatic && [2].includes(this.form.idEstado)
        default:
          return true
      }
    },
    submitAction: async function () {
      try {
        this.$store.commit('setIsLoading', true)

        const idAccion = this.selectedAction.IdAccion

        if (idAccion === 15) { // Rechazo de Factura Recibida
          this.toggleRejectDialog()
          return
        }

        const data = {
          idAccion,
          facturasCambio: [
            {
              IdInvoice: this.idInvoice,
              IdFacturae: this.idFacturae,
              Estado: this.idEstado,
            }
          ],
        }
        const response = await actualizarEstadoAccion(data)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          this.$router.push({ name: this.header.url })
        }
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    toggleRejectDialog: function () {
      this.rejectDialog = !this.rejectDialog
    },
    applyRejectDialog: async function (data) {
      this.toggleRejectDialog()
      // Realizar rechazo en API de GestionFacturas
      this.executeRejectHandler(data)
    },
    toggleCorretionDialog: function () {
      this.showCorrectionModal = !this.showCorrectionModal
    },
    applyCorretionDialog: async function (event) {
      this.toggleCorretionDialog()
    },
    toggleProformaDialog: function () {
      this.showProformaModal = !this.showProformaModal
    },
    applyProformaDialog: async function (event) {
      this.$router.push({ name: this.header.url })
      this.toggleProformaDialog()
    },
    toggleRecurrenceDialog: function () {
      this.showRecurrenceModal = !this.showRecurrenceModal
    },
    applyRecurrenceDialog: async function (event) {
      await this.downloadInvoiceData()
      this.toggleRecurrenceDialog()
      this.resetRecurrenceActions()
      this.genearateRecurrenceActions(this.editRecurrencia)
    },
    deleteRecurrenceHandler: async function () {
      try {
        this.$store.commit('setIsLoading', true)
        const response = await detenerFacturaRecurrente({ idFacturaRecurrente: this.idRecurrente })
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
          await this.downloadInvoiceData()
          this.resetRecurrenceActions()
          this.genearateRecurrenceActions()
        }
      } catch (error) {
        this.doFeedback()
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    executeRejectHandler: async function (rejectMessage = { idMensaje: -1, mensaje: '', fechaMensaje: Date.now() }) {
      try {
        this.$store.commit('setIsLoading', true)

        const idAccion = this.selectedAction.IdAccion
        rejectMessage.mensaje = rejectMessage.mensaje.trim()

        if (idAccion !== 15) {
          this.doFeedback(i18n.t('feedback.error.action_must_be_error', { action: i18n.t('configurations.reject_invoice') }))
          return
        }
        if (!rejectMessage.mensaje && rejectMessage.mensaje === '') {
          this.doFeedback(i18n.t('feedback.error.obligatory_field_error', { field: i18n.t('configurations.reject_msgs').toLowerCase() }))
          return
        }

        const data = {
          idAccion,
          facturasCambio: [
            {
              IdInvoice: this.idInvoice,
              IdFacturae: this.idFacturae,
              Estado: this.idEstado,
            }
          ],
          // rejectMessage,
          // TODO - Enviar objeto de mensaje para mensajes recientes
          mensaje: rejectMessage.mensaje,
        }

        const response = await actualizarEstadoAccion(data)
        if (response.blnError === true) {
          this.doFeedback(i18n.t('feedback.error.formated_api_response_error', response))
        } else {
          this.doFeedback(i18n.t('feedback.success.action_tramited_msg'), 'success')
        }
      } catch (error) {
        this.doFeedback(i18n.t('feedback.error.general'))
      } finally {
        this.$store.commit('setIsLoading', false)
      }
    },
    openUrlHacienda () {
      window.open(this.form.urlHacienda, '_blank')
    },
    openUrlVerifactu: function () {
      window.open(this.form.urlVerifactu, '_blank')
    },
    goVerifactu: function () {
      this.$router.push({ 
        name: 'verifactu/details',
        params: {
          IdCliente: parseInt(this.form.idCliente), 
          IdCifEmpresa: parseInt(this.form.IdNifEmpresa), 
          NumSerieFactura: this.form.NumSerieFact, 
          FechaExpedicion: this.form.FechaExpedicion,
          type: parseInt(this.form.IdEstadoVerifactu),
          CSVZCHistorico: this.form.CSVVerifactuZC 
        }
      })
    },
    goInvoice: function () {
      const invoiceType = this.form.EsRecibida ? 'received' : 'issued'
      this.redirectTo(
        {
          name: `invoices${invoiceType}/details`,
          params: {
            type: this.form.idEstadoRelacionado,
            idFacturae: this.form.idFacturaeRelacionado,
            idInvoice: this.form.idInvoiceRelacionado
          }
        },
        false
      )
    },
    genearateRecurrenceActions: function (isRecurrenceActive = false) {
      if (this.hasRecurrentesModule) {
        this.invoiceActions = this.invoiceActions.concat(this.listaAccionesRecurrentes)
        if (this.form.EstadoRecurrencia) {
          this.invoiceActions = this.invoiceActions.filter(x => x.IdAccion !== 26)
        } else {
          this.invoiceActions = this.invoiceActions.filter(x => x.IdAccion !== 27 && x.IdAccion !== 28)
        }
      }
    },
    generateAccionesWorkflow: function () {
      // Si hay flujo, no pueden coexistir (contabilizar, rechazar, envio a ERP)
      this.invoiceActions = this.invoiceActions.filter(x => x.IdAccion !== 14 && x.IdAccion !== 15 && x.IdAccion !== 18)
      const workflowActions = this.accionesFlujo.map(action => ({
        IdAccion: action.id,
        Descripcion: this.showEditModeOCRIA && action.NombreEdit ? action.NombreEdit : action.Nombre,
      }))

      const accionesWorkflow = (this.role === 3)
        ? workflowActions.filter(a => a.IdAccion === 302) // Super Admin: solo reasignar
        : this.isTurnWorkflow ? workflowActions : [] // Resto: todas si es su turno, nada si no
      this.invoiceActions = this.invoiceActions.concat(accionesWorkflow)
    },
    resetRecurrenceActions: function () {
      this.invoiceActions = this.invoiceActions.filter(x => x.IdAccion !== 26 && x.IdAccion !== 27 && x.IdAccion !== 28)
    }
  }
}
</script>

<style scoped>
.full-screen-pdf {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
}

.box {
  background-color: #444;
  color: #fff;
  border-radius: 5px;
  border: 1px solid black;
  padding: 5px 20px;
}

.grid {
  display: grid;
  grid-gap: 10px;
}

.wrapper {
  grid-template-columns: 1fr 1fr;
  background-color: seagreen;
  padding: 10px;
  width: 50%;
  margin: 20px auto;
}

.grid.left {
  grid-column: 1 / span 1;
  grid-auto-rows: min-content;
}

.grid.right {
  grid-column: span 1 / -1;
  grid-auto-rows: min-content;
}

.tip {
  grid-column: 1 / -1;
}

.pic>img {
  max-width: 100%;
  max-height: 100%;
}

@media (min-width: 1024px) {
  ::v-deep .right-col {
    height: var(--left-height);
    overflow: hidden;
  }
}

/* Permite que el mensaje de validación del el-form-item empuje el contenido dentro
   de las celdas de la tabla y se lea completo (por defecto es position: absolute y
   queda recortado por el overflow de la celda). */
::v-deep .importes-table .el-form-item {
  margin-bottom: 0;
}
::v-deep .importes-table .el-form-item__error {
  position: static;
  padding-top: 2px;
  white-space: normal;
  word-break: break-word;
  line-height: 1.2;
}
/* Alinea el contenido de las celdas arriba para que, al aparecer un mensaje de
   validación bajo un input, el resto de celdas de la fila no se descoloquen. */
::v-deep .importes-table .el-table__row > td .cell {
  vertical-align: top;
}
::v-deep .importes-table .el-table__row > td {
  vertical-align: top;
}
</style>

<style lang="scss" >
.hideHeader {
  display: none
}

.showHeader {
  display: block
}

.hideHScroll {
  overflow-x: hidden;
}

.iframe-xhtml {
  width: 100%;
  height: 100%;
}
.min-input-height {
    padding: .25rem 0 0.70rem 0;
}
</style>
